import { ArrowRight, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { heroImage, heroImageAlt } from "@/data/eventOrganizerContent";

const HeroSection = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="luxury-hero relative min-h-[86vh] overflow-hidden rounded-[2rem] border border-fuchsia-100/70">

      <img
        src={heroImage}
        alt={heroImageAlt}
        data-testid="hero-background-image"
        className="absolute inset-0 h-full w-full object-cover object-center" />

      <div className="absolute inset-0 bg-[linear-gradient(115deg,rgba(37,22,55,0.88)_20%,rgba(77,47,106,0.62)_56%,rgba(167,139,250,0.35)_100%)]" />

      <div className="relative z-10 grid min-h-[86vh] items-center px-6 py-20 md:px-10 lg:px-16">
        <div className="max-w-3xl space-y-7 text-stone-50">
          <p
            data-testid="hero-eyebrow-text"
            className="fade-up inline-flex items-center gap-2 rounded-full border border-fuchsia-100/70 bg-white/10 px-4 py-2 text-xs uppercase tracking-[0.18em] text-fuchsia-100">

            <CalendarCheck className="h-3.5 w-3.5" />
            RJL Events HK · Asia Pacific Corporate Events Strategy & Execution
          </p>
          <h1
            data-testid="hero-main-heading"
            className="fade-up delay-100 text-4xl leading-tight sm:text-5xl lg:text-6xl">Corporate events that perform.


          </h1>
          <p
            data-testid="hero-subheading-text"
            className="fade-up delay-200 max-w-2xl text-sm leading-relaxed text-stone-200 md:text-lg">End-to-end event management with content generation, speaker acquisition, marketing strategy, and master of ceremony services—delivered for conferences, summits, launches, and executive events across Asia Pacific, based in Hong Kong.



          </p>
          <div className="fade-up delay-300 flex flex-wrap gap-4">
            <Button
              asChild
              className="h-11 rounded-full bg-fuchsia-600 px-7 text-xs font-semibold uppercase tracking-wider text-white hover:bg-fuchsia-700"
              data-testid="hero-book-consultation-button">

              <a href="#consultation" aria-label="Book corporate consultation">
                Book Corporate Consultation
                <ArrowRight className="h-4 w-4" />
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              className="h-11 rounded-full border-fuchsia-100/80 bg-white/5 px-7 text-xs font-semibold uppercase tracking-wider text-stone-50 hover:bg-white/15"
              data-testid="hero-view-portfolio-button">

              <a href="#corporate-profile" aria-label="View corporate profile">
                View Corporate Profile
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;